import elementoVisivel from '../dom';

const SELECTOR_ABA = '[data-tour="sessao-arp"]';
const SELECTOR_HUB = '[data-tour="arp-hub"]';
const SELECTOR_NOVA = '[data-tour="arp-nova-ata"]';
const SELECTOR_CHOICE = '[data-tour="arp-choice"]';
const SELECTOR_VENCEDOR = '[data-tour="arp-choice-vencedor"]';
const SELECTOR_RESERVA = '[data-tour="arp-choice-reserva"]';
const SELECTOR_PROPRIA = '[data-tour="arp-choice-propria"]';

function clicarAbaArp() {
  const label = document.querySelector(SELECTOR_ABA);
  if (!label) return;
  const trigger =
    label.closest('a') || label.closest('li')?.querySelector('a') || label.parentElement || label;
  trigger.click();
}

function abrirNovaAta() {
  const botao = document.querySelector(SELECTOR_NOVA);
  if (botao) {
    botao.click();
    return;
  }
  clicarAbaArp();
}

export default {
  id: 'arp-jornadas',
  kind: 'tour',
  version: 1,
  label: 'ARP — jornadas de cadastro',
  contexts: ['auction.arp'],
  scopes: ['hub'],
  priority: 10,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.canAccessArp && !ctx.journeyActive);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.canAccessArp) return false;
    return elementoVisivel(SELECTOR_ABA);
  },
  steps() {
    const steps = [
      {
        element: SELECTOR_ABA,
        popover: {
          title: 'Nova aba ARP',
          description:
            'A Ata de Registro de Preços agora tem uma aba própria na sessão. Ela não fica mais dentro de Editar pregão — use esta aba para cadastrar, editar e publicar as ARPs do certame.',
          side: 'bottom',
          align: 'start',
          onNextClick: (element, step, { driver }) => {
            clicarAbaArp();
            driver.moveNext();
          },
        },
      },
      {
        element: SELECTOR_HUB,
        waitForElement: 2000,
        popover: {
          title: "ARP's Cadastradas",
          description:
            'Aqui ficam todas as atas deste pregão de registro de preços: rascunhos, publicadas e ações como baixar, editar, enviar assinada ou excluir.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    // waitForElement: o botão só existe após a aba abrir (passo anterior).
    steps.push({
      element: SELECTOR_NOVA,
      waitForElement: 2000,
      popover: {
        title: 'Nova Ata de Registro de Preços',
        description:
          'Inicie o cadastro por aqui. No próximo passo você escolhe o tipo de jornada: vencedor, cadastro reserva ou ARP própria.',
        side: 'left',
        align: 'start',
        onNextClick: (element, step, { driver }) => {
          abrirNovaAta();
          driver.moveNext();
        },
      },
    });

    steps.push({
      element: SELECTOR_CHOICE,
      waitForElement: 2500,
      popover: {
        title: 'Escolha a jornada',
        description:
          'São três formas de registrar a ARP neste certame. Escolha a que corresponde à origem da ata.',
        side: 'top',
        align: 'start',
      },
    });

    steps.push({
      element: SELECTOR_VENCEDOR,
      waitForElement: 2500,
      popover: {
        title: 'ARP para um Vencedor',
        description:
          'Gera a ata para o fornecedor vencedor, com os itens e valores adjudicados/homologados em favor dele.',
        side: 'bottom',
        align: 'start',
      },
    });

    steps.push({
      element: SELECTOR_RESERVA,
      waitForElement: 2500,
      popover: {
        title: 'ARP do Licitante Convocado',
        description:
          'Esta opção deve ser utilizada após a convocação do próximo licitante do Cadastro de Reserva. Gere a ARP individual do fornecedor convocado para os itens/lotes assumidos, mantendo os preços registrados e a ordem de classificação do certame.',
        side: 'bottom',
        align: 'center',
      },
    });

    steps.push({
      element: SELECTOR_PROPRIA,
      waitForElement: 2500,
      popover: {
        title: 'Enviar ARP Própria',
        description:
          'Use quando a ARP já foi elaborada fora do SEL: informe os metadados, vincule itens e envie o PDF.',
        side: 'bottom',
        align: 'end',
      },
    });

    return steps;
  },
};
